var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionnaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.81714H0V18.8171C0 19.9171 0.9 20.8171 2 20.8171H16V18.8171H2V4.81714Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.817139H6C4.9 0.817139 4 1.71714 4 2.81714V14.8171C4 15.9171 4.9 16.8171 6 16.8171H18C19.1 16.8171 20 15.9171 20 14.8171V2.81714C20 1.71714 19.1 0.817139 18 0.817139ZM12.01 13.8171C11.42 13.8171 10.96 13.3471 10.96 12.7671C10.96 12.1771 11.43 11.7271 12.01 11.7271C12.6 11.7271 13.05 12.1771 13.05 12.7671C13.04 13.3471 12.6 13.8171 12.01 13.8171ZM14.51 7.64714C13.88 8.57714 13.28 8.85714 12.95 9.45714C12.82 9.69714 12.77 9.85714 12.77 10.6371H11.25C11.25 10.2271 11.19 9.55714 11.51 8.98714C11.92 8.25714 12.69 7.82714 13.14 7.18714C13.62 6.50714 13.35 5.24714 12 5.24714C11.12 5.24714 10.68 5.91714 10.5 6.47714L9.13 5.90714C9.51 4.77714 10.52 3.81714 11.99 3.81714C13.22 3.81714 14.07 4.37714 14.5 5.07714C14.87 5.68714 15.08 6.80714 14.51 7.64714Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/questionnaire.265e94cf8a708463ef77b8e237e6cd4f.svg";
export { ForwardRef as ReactComponent };